<template>
  <div class="setting-layout layout-page">
    <div class="tabs clear">
      <Tabs v-model="pageIndex" line-width="56px" color="#353945" title-active-color="#353945" title-inactive-color="#9FA4AD" @change="chagneTab">
        <Tab :title="$t('zi-chan-guan-li-0')">
          <div class="layout-main">
            <router-view v-if="pageIndex == 0"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('pageTitle.account1')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 1"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('pageTitle.account2')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 2"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('pageTitle.account3')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 3"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('pageTitle.account4')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 4"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('pageTitle.account6')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 5"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('assestLog.title')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 6"></router-view>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant';
export default {
  components: {
    Tabs,
    Tab
  },
  data() {
    return {
      pageIndex: 0
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let name = this.$route.name
      if (name == 'assest') {
        this.pageIndex = 0
      } else if (name == 'assestLog') {
        this.pageIndex = 6
      } else if (name == 'account') {
        let type = this.$route.query.type
        this.pageIndex = type == 6 ? 5 : type
      }
    },
    chagneTab() {
      let name = ''
      let type = ''
      switch(this.pageIndex) {
        case 0: name = 'assest'; break;
        case 1: name = 'account'; type = 1; break;
        case 2: name = 'account'; type = 2; break;
        case 3: name = 'account'; type = 3; break;
        case 4: name = 'account'; type = 4; break;
        case 5: name = 'account'; type = 6; break;
        case 6: name = 'assestLog'; break;
      }
      if(name) {
        this.$router.push({
          name: name,
          query: type ? {
            type
          } : {}
        })
      }
    }
  }
}
</script>